// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"c-b_gt"};